import { Link } from "react-router";

interface ThemeToggleProps {
  isDarkMode: boolean;
  onToggle: () => void;
}

const ThemeToggle = ({ isDarkMode, onToggle }: ThemeToggleProps) => {
  return (
    <div className="header-theme header-theme-two">
      <Link
        to="#"
        id="dark-mode-toggle"
        className={`theme-toggle moon ${isDarkMode ? "active" : "activate"}`}
        onClick={onToggle}
      >
        <i className="isax isax-moon5" />
      </Link>

      <Link
        to="#"
        id="light-mode-toggle"
        className={`theme-toggle sun ${!isDarkMode ? "active" : "activate"}`}
        onClick={onToggle}
      >
        <i className="isax isax-sun-15" />
      </Link>
    </div>
  );
};

export default ThemeToggle;
